import React from 'react';
import { motion } from 'framer-motion';

/**
 * TimelineBar - horizontal bar showing enforced periods (teal) and gaps (red).
 * gaps: array of {start: 0..1, end: 0..1, events?: number}
 */
export default function TimelineBar({
  label,
  enforcementPct = 100,
  gaps = [],
  framework,
  testId,
  onClick,
}) {
  return (
    <div data-testid={testId} className="space-y-1.5">
      <div className="flex items-center justify-between text-xs">
        <div className="flex items-center gap-2 min-w-0">
          <span className="font-medium text-apex-ink truncate">{label}</span>
          {framework && (
            <span className="text-[10px] font-mono text-apex-neutral border border-slate-200 px-1.5 rounded">{framework}</span>
          )}
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <span className={`tabular text-[11px] font-semibold ${enforcementPct >= 99 ? 'text-apex-success' : enforcementPct >= 95 ? 'text-apex-warning' : 'text-apex-critical'}`}>
            {enforcementPct}%
          </span>
          <span className="text-[10px] text-apex-neutral">{gaps.length} gap{gaps.length !== 1 ? 's' : ''}</span>
        </div>
      </div>
      <div className="relative h-2 bg-slate-100 rounded-full overflow-hidden" onClick={onClick}>
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: '100%' }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="absolute inset-0 bg-apex-success/80"
        />
        {gaps.map((g, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3 + i * 0.1 }}
            className="absolute top-0 bottom-0 bg-apex-critical group cursor-pointer"
            style={{ left: `${g.start * 100}%`, width: `${(g.end - g.start) * 100}%` }}
            title={`Gap: ${g.days || ''} days · ${g.events || 0} events`}
          />
        ))}
        {gaps.flatMap((g) => g.events ? [...Array(Math.min(g.events, 5))].map((_, j) => ({ pos: g.start + ((g.end - g.start) / Math.min(g.events, 5)) * j })) : []).map((m, i) => (
          <span key={i} className="absolute top-1/2 -translate-y-1/2 w-0.5 h-3 bg-white" style={{ left: `${m.pos * 100}%` }} />
        ))}
      </div>
    </div>
  );
}
